import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SupplierconsumptionReducer(state = initialState.supplierconsumptionContent, action: any) {
  switch (action.type) {
    case types.SAVE_SUPPLIERCONSUMPTIONCONTENT_SUCCESS:
      return action.supplierconsumptionContent;
    default:
      return state;
  }
}
